import React, { useState } from "react";
import List from "../productionOrderSapList";
import Filter from "../productionOrderSapFilter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import Breadcrumb from "../../../utils/breadCrumbs";
import useFilterState from "../../../../utils/hooks/useFilterState";
import moment from "moment-timezone";
import { getDateFormatTimeZone } from "../../../../utils/formats";
import * as ProductionOrderSapServices from "../../../../services/ProductionOrderSapService";
import * as XLSX from "xlsx";
import { POSAP_STATUS } from "../../../../constants";

const queryClient = new QueryClient();

const ProductionOrderSapFilterListContainer = (props) => {
  const { t } = useTranslation();
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.productionOrderSap.title") },
  ];
  const [showNotificated, setShowNotificated] = useState(false);

  const [filters, setFilters] = useFilterState("productionOrderSap");
  const navigate = useNavigate();

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    setFilters(undefined);
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });
    setFilters(newFilter);
  };

  const exportToExcel = async () => {
    const filter = {
      filters: { ...filters },
      sort: "-date",
    };
    ProductionOrderSapServices.listToExport(filter).then((result) => {
      const data = result.map((item) => {
        const type =
          item.sapProductionVersion === "0004"
            ? "REPROCESO PARTIDORA"
            : item.type;
        // const status = t(POSAP_STATUS.find((st) => st.code === item.status));

        return {
          A: getDateFormatTimeZone(new Date(item.sapStartDate), "DD-MM-yyyy"),
          B: getDateFormatTimeZone(new Date(item.createdAt), "DD-MM-yyyy"),
          C: item.idOrderSap|| "-",
          D: item.sapPlant|| "-",
          E: item.sapProduct|| "-",
          F: item.sapQuantity || "-",
          G: item.sapProductionVersion || "-",
          H: type || "-",
          I: item.status|| "-",
        };
      });
      data.unshift({
        A: "Fecha producción",
        B: "Fecha creación",
        C: "Orden SAP",
        D: "Código Centro",
        E: "Producto",
        F: "Cantidad",
        G: "Versión",
        H: "Tipo",
        I: "Estado",
      });

      const filename = `Order_SAP_export_${moment(new Date()).format(
        "DDMMyyyyHHmm",
      )}`;
      const sheetName = "Listado de órdenes SAP";
      var ws = XLSX.utils.json_to_sheet(data, {
        header: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
        skipHeader: true,
        UTC: true,
        dateNF: "dd-mm-yyyy hh:mm;@",
      });
      // dateNF:'mm/dd/yyyy;@',cellDates:true, raw: true}
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, filename + ".xlsx");
    });
  };

  return (
    <>
      <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.productionOrderSap.title")}</h3>
        </div>
      </div>
      <Breadcrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
            initialValues={filters}
          />
        </div>
      </div>
      <div className="row justify-content-center no-margin">
        <div className="col-12 col-md-11 mt-3 text-end">
          <button
            type="button"
            className="btn btn-md btn-secondary"
            onClick={() => exportToExcel()}
          >
            <i className="fa-solid fa-file-excel icon-button"></i>{" "}
            {t("exportFileExcel")}
          </button>
        </div>
      </div>
      
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <QueryClientProvider client={queryClient}>
            <List
              className="marg-top-1rem"
              filters={{ ...filters }}
            />
          </QueryClientProvider>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-11 d-flex justify-content-center">
          {/*<button
            className="btn btn-secondary btn-lg"
            //onClick={() => goToForm()}
          >
            {t("forms.order.buttons.new")}
          </button>*/}
        </div>
      </div>
    </>
  );
};

ProductionOrderSapFilterListContainer.propTypes = {};

export default ProductionOrderSapFilterListContainer;
